var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"position-absolute px-0 alert-container",attrs:{"fluid":""}},[_c('b-alert',{staticClass:"m-0 rounded-0",attrs:{"show":"","fade":"","variant":_vm.alert.variant,"dismissible":""}},[_vm._v(" "+_vm._s(_vm.alert.msg)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }